import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=1ddc0c24&scoped=true"
import script from "./maintenance.vue?vue&type=script&lang=ts"
export * from "./maintenance.vue?vue&type=script&lang=ts"
import style0 from "./maintenance.vue?vue&type=style&index=0&id=1ddc0c24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc0c24",
  null
  
)

export default component.exports